//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
const { types, uiTypes , referenceTypes} = require("./utils/types");
const { validatorTypes } = require("./utils/validatorTypes");

const models = [
  {
    tableName: "product",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [
      {
        tableName: "product_category",
        foreignKey: "product_category_id",
        primaryKey: "id",
        type: referenceTypes.ONE,
        displayKey: "name",
      },
    ],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "product_category_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "price",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "cgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "photo",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.url, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.IMAGE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "parcel_charge",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        defaultValue: 0.0,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "enabled",
        type: types.BOOLEAN,
        isArray: false,
        allowNull: true,
        defaultValue: true,
        validation: [validatorTypes.bool, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.SWITCH, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "out_of_stock",
        type: types.BOOLEAN,
        isArray: false,
        allowNull: true,
        defaultValue: false,
        validation: [validatorTypes.bool, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.SWITCH, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },

  {
    tableName: "product_category",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "active",
        type: types.BOOLEAN,
        isArray: false,
        allowNull: true,
        defaultValue: true,
        validation: [validatorTypes.bool, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.SWITCH, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },

  {
    tableName: "customer",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "phone",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.mobile, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },

  {
    tableName: "orders",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [
      {
        tableName: "customer",
        foreignKey: "customer_id",
        primaryKey: "id",
        type: referenceTypes.ONE,
        displayKey: "name",
      },
      {
        tableName: "restaurant_tables",
        foreignKey: "restaurant_table_id",
        primaryKey: "id",
        type: referenceTypes.ONE,
        displayKey: "name",
      },
    ],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "invoice_number",
        type: types.INTEGER,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "customer_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "restaurant_table_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "name",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "phone",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.mobile, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "total_before_tax",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "discount",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        defaultValue: 0.0,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "cgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "total_after_tax",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
       {
        name: "total_after_tax_with_discount_parcel_charge",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "order_type",
        type: types.ENUM,
        allowNull: false,
        defaultValue: "dining",
        enumValues: ["parcel", "dining"],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [validatorTypes.string, validatorTypes.optional],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "payment_method",
        type: types.ENUM,
        allowNull: true,
        defaultValue: null,
        enumValues: ["online", "cash"],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [validatorTypes.string, validatorTypes.optional],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "parcel_charge",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        defaultValue: 0.0,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "completed",
        type: types.BOOLEAN,
        isArray: false,
        allowNull: false,
        defaultValue: false,
        validation: [validatorTypes.bool, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.SWITCH, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },

  {
    tableName: "restaurant_tables",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "location",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "status",
        type: types.ENUM,
        allowNull: true,
        defaultValue: null,
        enumValues: ["occupied", "not-occupied"],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [validatorTypes.string, validatorTypes.optional],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },
  {
    tableName: "order_products",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [
      {
        tableName: "orders",
        foreignKey: "order_id",
        primaryKey: "id",
        type: referenceTypes.ONE,
        displayKey: "id",
      },
      {
        tableName: "product",
        foreignKey: "product_id",
        primaryKey: "id",
        type: referenceTypes.ONE,
        displayKey: "name",
      },
    ],
    comments: true,
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "order_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "product_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "group_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
 {
        name: "product_category_id",
        type: types.UUID,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.DROPDOWN, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "price",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "cgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sgst",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "photo",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.url, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.IMAGE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "parcel_charge",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        defaultValue: 0.0,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },

      {
        name: "qty",
        type: types.INTEGER,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },

      {
        name: "total_before_tax",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.NUMBER, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
       {
        name: "cgst_total",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.NUMBER, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sgst_total",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.NUMBER, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "total_after_tax",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.NUMBER, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
     
      {
        name: "parcel_charge_total",
        type: types.DOUBLE,
        isArray: false,
        allowNull: true,
        defaultValue: 0.0,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
     
      {
        name: "request",
        type: types.STRING,
        isArray: false,
        allowNull: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },
];

module.exports = models;
